import React from "react";
import { SupTooltip, SupCopy } from "@repo/core-ui";

export interface TxFormattedValueProps {
  value: string;
  formatter?: (value: string) => string;
  onCopy?: (value: string) => void;
}

export function SupTxFormattedValue({ value, formatter, onCopy }: TxFormattedValueProps) {
  async function handleCopy() {
    await navigator.clipboard.writeText(value);
    onCopy?.(value);
  }

  return (
    <div className="inline-flex items-center gap-2 whitespace-nowrap">
      <SupTooltip unmount portal color="primary" popperElClassName="normal-case" content={value}>
        <span className="cursor-default underline normal-case">{formatter?.(value) ?? value}</span>
      </SupTooltip>

      <button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          void handleCopy();
        }}
      >
        <SupCopy />
      </button>
    </div>
  );
}
